// src/containers/campaigns.js
import Campaigns from '../components/pages/campaigns';

export default Campaigns;